import { useState, useEffect } from "react";

/**
 * Custom input de tipo texto como default
 * pasar una funcion de validación si se requiere que el input responda a diversas condiciones
 * esta función de validación deberá un booleano ya sea true o false, para indicarle si pasa o no ese valor
 * @param {*} param0 
 * @returns 
 */

const InputText = ({
    inputLabel = "inputLabel",
    inputField,
    required,
    changingInput,
    disabled,
    readOnly,
    extraStyle = "",
    type = "text",
    id,
    validationFunction = null
}) => {

    const [isFocused, setIsFocused] = useState(false);
    const [val, setVal] = useState(inputField ? inputField : "");

    useEffect(() => {
        setVal(inputField ? inputField : "");
    }, [inputField]);
    

    useEffect(() => {
        if (val) {
            setIsFocused(true)
        } else {
            setIsFocused(false)
        }
    }, [val])

    const handleFocus = (event) => {
        setIsFocused(true);
    };

    const handleBlur = (event) => {
        val ? setIsFocused(true) : setIsFocused(false);
    };

    const handleOnChangeInput = (e) => {
        let pass = validationFunction ? validationFunction(e) : true;

        if (pass) {
            setVal(e.target.value);
            changingInput(e);
        }
        
    };

    return (
        <div className={`form-group ${isFocused ? "focused" : ""}`}>
            <label className="form-label" htmlFor={id}>
                {inputLabel}
            </label>
            <input
                id={id}
                className={`form-input ${val ? "has-value" : ""} ${extraStyle !== "" ? extraStyle : ""}`}
                type={"text"}
                onFocus={handleFocus}
                onBlur={handleBlur}
                name={inputLabel}
                value={val}
                onChange={handleOnChangeInput}
                required={required}
                disabled={disabled}
                readOnly={readOnly}
                autoComplete='off'
            />
        </div>
    );
};

export default InputText;
